import type { SidePanel } from '../types';

export const SmsSign: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./SmsSign.vue')),
};
